import { useState, useEffect, useContext } from 'react';
import { FetchContext } from '@src/scenario-editor/providers/fetch.context';
export type { FetchAllScenarioPayload } from '@src/scenario-editor/providers/fetch.context';

interface ScenarioItem {
  id: string;
  name: string;
}

export const useFetchScenario = () => {
  const [allScenario, setAllScenario] = useState<ScenarioItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const fetchContext = useContext(FetchContext);

  if (!fetchContext) {
    throw new Error('FetchContext is not provided');
  }

  useEffect(() => {
    const fetchAllMessages = async () => {
      try {
        setIsLoading(true);
        const allScenarioData = await fetchContext.fetchAllScenario();
        setAllScenario(allScenarioData.data);
        setIsLoading(false);
      } catch (e) {
        console.error(e);
      }
    };
    fetchAllMessages().catch(console.error);
  }, [fetchContext]);

  return [allScenario, isLoading];
};
